import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	dismissMessage: {
		id: 'new-product-message-banner-dismiss-message',
		defaultMessage: 'Dismiss',
		description: 'Message for button to dismiss the new product banner',
	},
	assetsAsAnAppBannerText: {
		id: 'assets-search-available-soon-message-banner',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			'<bold>Assets will be available here soon</bold>. For now, try <assetsSearchLink>Assets search</assetsSearchLink>.',
		description: 'Text for banner appearing above search results',
	},
});
